import {ValueObject} from '@s-ui/domain'

export default class ProductsListValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array} data.products
   * */

  getProducts = () => this._products
}
